import http from '~/utils/http'

/** 获取所有套餐 */
export function getAppointment(page: number, size: number, status?: string) {
  return http.get('/admin/appointment', {
    params: {
      page,
      size,
      status,
    },
  })
}

export interface DesiredBookingTeacher {
  id: number
  name: string
  cardsPerLesson: number
}

export interface DesiredUploadedSlot {
  from: number
  to: number
}

export function getDesiredUploadedSlots(
  teacherId: number,
  from: number,
  to: number,
) {
  return http.get<DesiredUploadedSlot[]>(
    `/admin/desired-appointments/teachers/${teacherId}/uploaded-slots`,
    { params: { from, to } },
  )
}

export function getDesiredBookingTeachers(query: string) {
  return http.get<DesiredBookingTeacher[]>(
    '/admin/desired-appointments/teachers',
    { params: { query } },
  )
}

export function createAdminDesiredAppointment(data: {
  studentId: string
  teacherId: number
  classStartTime: number
  remark: string
}) {
  return http.post<{ id: number; status: string; desiredExpiresAt: number }>(
    '/admin/desired-appointments',
    data,
  )
}
